import { MessageBar, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";

export function ErrorState({
  title,
  message,
}: {
  title: string;
  message: string;
}) {
  return (
    <div style={{ padding: 24 }}>
      <MessageBar intent="error">
        <MessageBarBody>
          <MessageBarTitle>{title}</MessageBarTitle>
          {message}
        </MessageBarBody>
      </MessageBar>
    </div>
  );
}
